import React from "react";
import { useTranslation } from "react-i18next";

export default function Privacy() {
  const { t } = useTranslation();
  const sections = t("privacy.sections", { returnObjects: true }) || [];
  return (
    <article className="fp-legal">
      <header className="fp-legal__head">
        <span className="fp-eyebrow">{t("policies_teaser.eyebrow")}</span>
        <h1>{t("privacy.title")}</h1>
        <p className="fp-legal__meta">{t("privacy.updated")}</p>
      </header>
      <p className="fp-legal__intro">{t("privacy.intro")}</p>
      <div className="fp-legal__body">
        {Array.isArray(sections) && sections.map((s, i) => (
          <section key={i}>
            <h2>{s.h}</h2>
            <p>{s.p}</p>
          </section>
        ))}
      </div>
    </article>
  );
}
